/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import Render from '@ion/dls/src/render/Render';

interface IdentifierResultsType {
  setShowDialog?: (showDialog: boolean) => void;
  dataSections?: string;
  itemLength?: number;
  moreItem?: number;
};

/**
 * Defines the IdentifierMoreCount component. This component is used to
 * display remaining groups count.
 *
 * ```typescript
 *
 *   import IdentifierMoreCount from './IdentifierMoreCount';
 *
 *   <IdentifierMoreCount dataSections={dataSections}
 *     setShowDialog={setShowDialog}
 *     itemLength={itemLength}
 *     moreItem={moreItem} />
 *
 * ```
 */
const IdentifierMoreCount = ({
  setShowDialog,
  dataSections,
  itemLength,
  moreItem
}: IdentifierResultsType) => {
  const handleMoreIdentifier = (open = false) => {
    return function(e) {
      e.preventDefault();
      setShowDialog(open);
    };
  };

  return (
    <Render.If condition={itemLength > 0}>
      <div className={dataSections}
        onClick={handleMoreIdentifier(true)}>
        <span>{moreItem}</span>
      </div>
    </Render.If>
  );
};

export default React.memo(IdentifierMoreCount);
